import StoryCategories from '@/blogBuilder/components/Categories/Story'
import HeroBanner from '@/blogBuilder/components/HeroBanner/Story/index'
import Layout from '@/blogBuilder/components/Layout'
import Breadcrumbs from '@/siteBuilder/blocks/core/Breadcrumbs/Breadcrumbs'
import Preview from '@/blogBuilder/components/Preview'
import ArticleProvider from '@/blogBuilder/provider/ArticleProvider'
import Head from '@/siteBuilder/components/Head/Head'
import { getBreadcrumbData } from '../../utils/breadcrumbSlugs'
import { filterTags } from '../../utils/types/theme'
import type { GenericBlogProps } from '../../utils/types/theme'
import type { TypeSeoTagsFields, TypeSeoTagsWithoutUnresolvableLinksResponse } from '@/contentful-types'
import { Spacer } from '@telus-uds/components-web'

const Story = ({ genericBlogTemplate, locale, fullBlogUrls, breadcrumbs }: GenericBlogProps) => {
  const isCategorySeparationDisabled = genericBlogTemplate?.isCategorySeparationDisabled
  const slugsToRender = getBreadcrumbData(breadcrumbs, locale.language)

  const articles = genericBlogTemplate.categories.filter((category) => category.fields.articles)

  const filterTags = genericBlogTemplate.categories
    .flatMap((category) => {
      return { tags: category.fields.filterTags, category: category.fields.name }
    })
    .filter((d) => d.tags)

  const filterTagsWithAll: { tags: filterTags; category: string }[] = genericBlogTemplate?.filterTags
    ? [...filterTags, { tags: genericBlogTemplate.filterTags, category: 'All' }]
    : filterTags

  return (
    <Layout hasGreyBackground={false}>
      <Head
        title={genericBlogTemplate?.seo?.fields?.metaTitle}
        language={locale.language}
        seo={genericBlogTemplate.seo?.fields as unknown as TypeSeoTagsWithoutUnresolvableLinksResponse['fields']}
      />
      <ArticleProvider
        navigationOptions={genericBlogTemplate?.navigationOptions || 'Show More'}
        lang={locale.language}
        categories={genericBlogTemplate.categories}
        {...{ isCategorySeparationDisabled }}
      >
        {breadcrumbs && <Breadcrumbs breadcrumbs={slugsToRender} />}
        <HeroBanner
          image={genericBlogTemplate?.heroImage?.fields}
          mobileImage={genericBlogTemplate?.heroImageMobile?.fields}
          title={genericBlogTemplate.title}
          description={genericBlogTemplate.description}
        />
        <Spacer space={{ xs: 4, md: 8 }} />
        <StoryCategories />
        {articles.length && (
          <Preview
            navigationOptions={genericBlogTemplate?.navigationOptions || 'Show More'}
            blogs={genericBlogTemplate.categories}
            lang={locale.language}
            fullBlogUrls={fullBlogUrls}
            theme="story"
            filterTags={filterTagsWithAll}
          />
        )}
      </ArticleProvider>
    </Layout>
  )
}

export default Story
